<template>
  <v-expand-transition mode="out-in">
    <div v-if="alertIsShown">
      <div class="warning-opacity py-4 d-flex justify-center align-center px-4">
        <span class="text-body-2 text-warning font-weight-medium">{{ text }}</span>
        <c-close-btn
          class="ml-3"
          color="transparent"
          icon-class="text-warning"
          width="7"
          height="7"
          @click="alertIsShown = !alertIsShown"
        />
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
  import { CCloseBtn } from '@clickadilla/components/components'

  export default {
    name: 'AdBlockAlert',
    components: { CCloseBtn },
    props: {
      text: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        alertIsShown: true
      }
    }
  }
</script>

<style scoped lang="scss">
  .warning-opacity {
    background-color: color-mix(in srgb, rgb(var(--v-theme-warning)) 15%, transparent);
  }
</style>
